// Utility to handle icon fallbacks gracefully

// Check if icon font is loaded
export const isIconFontLoaded = () => {
  // Create a test element to check if icon font is available
  const testElement = document.createElement('span');
  testElement.className = 'icon icon-increment';
  testElement.style.position = 'absolute';
  testElement.style.visibility = 'hidden';
  testElement.style.fontSize = '16px';
  
  document.body.appendChild(testElement);
  
  // Get computed styles
  const computedStyle = window.getComputedStyle(testElement);
  const fontFamily = computedStyle.fontFamily;
  
  // Clean up
  document.body.removeChild(testElement);
  
  // Check if custom icon font is loaded (adjust font name as needed)
  return fontFamily.includes('icon') || fontFamily.includes('icomoon') || fontFamily.includes('fontawesome');
};

// Add fallback text for buttons without icons
export const addIconFallbacks = (buttonElement, iconType) => {
  const iconSpan = buttonElement.querySelector('.bs-counter-widget__icon');
  
  if (!iconSpan) return;
  
  // Check if icon is actually displaying content
  const hasIconContent = iconSpan.offsetWidth > 0 && iconSpan.offsetHeight > 0;
  
  if (!hasIconContent || !isIconFontLoaded()) {
    // Remove icon classes and add text fallback
    iconSpan.className = 'bs-counter-widget__icon-fallback';
    iconSpan.textContent = iconType === 'increment' ? '+' : '−';
    iconSpan.style.fontWeight = 'bold';
    iconSpan.style.fontSize = '16px';
    iconSpan.style.lineHeight = '1';
  }
};

// Initialize icon fallbacks for counter widget
export const initializeIconFallbacks = (counterWidgetElement) => {
  if (!counterWidgetElement) return;
  
  const incrementBtn = counterWidgetElement.querySelector('.bs-counter-widget__increment-btn');
  const decrementBtn = counterWidgetElement.querySelector('.bs-counter-widget__decrement-btn');
  
  if (incrementBtn) {
    addIconFallbacks(incrementBtn, 'increment');
  }
  
  if (decrementBtn) {
    addIconFallbacks(decrementBtn, 'decrement');
  }
};

// Observer to handle dynamically added counter widgets
export const observeCounterWidgets = () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the added node is a counter widget
            if (node.classList?.contains('bs-counter-widget')) {
              setTimeout(() => initializeIconFallbacks(node), 100);
            }
            
            // Check if the added node contains counter widgets
            const counterWidgets = node.querySelectorAll?.('.bs-counter-widget');
            if (counterWidgets?.length > 0) {
              counterWidgets.forEach(widget => {
                setTimeout(() => initializeIconFallbacks(widget), 100);
              });
            }
          }
        });
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  return observer;
};